// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-picker.v5-datepicker .picker-panel .wheel-wrapper{padding:0 .8666666667rem}", ""]);
// Exports
module.exports = exports;
